export default "__VITE_ASSET__V9D4aJd$__"